const limitPayoutColumns = {
  data: ['BET', 'PAYOUT'],
  title: 'LIMITS_AND_PAYOUTS',
};

const resultColumns = {
  data: ['ROUND_ID', 'RESULT', 'CHECK'],
  title: 'RESULT',
};

const additionalResultTitle = 'LAST_CARDS';

export { resultColumns, limitPayoutColumns, additionalResultTitle };
